import { deflateSync, strToU8 } from 'fflate';

// Cloudflare caps WebSocket messages at 1 MiB: full DOM snapshots must be split below that. The sales console
// (cobrowse-relay, console/src/lib/recordingDecoder.ts) reads this exact frame layout.
const DEFAULT_CHUNK_SIZE = 512 * 1024;
const HEADER_SIZE = 8;

export function encodeRecording(events: unknown[], batchId: number, chunkSize = DEFAULT_CHUNK_SIZE): Uint8Array[] {
    const payload = deflateSync(strToU8(JSON.stringify(events)));
    const chunkCount = Math.max(1, Math.ceil(payload.length / chunkSize));
    const frames: Uint8Array[] = [];

    for (let index = 0; index < chunkCount; index++) {
        const chunk = payload.subarray(index * chunkSize, (index + 1) * chunkSize);
        const frame = new Uint8Array(HEADER_SIZE + chunk.length);
        const header = new DataView(frame.buffer);

        header.setUint32(0, batchId);
        header.setUint16(4, index);
        header.setUint16(6, chunkCount);
        frame.set(chunk, HEADER_SIZE);
        frames.push(frame);
    }

    return frames;
}
